import { EJQuickLinks } from '../../../../constants/cimsPage/instances/ej'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: EJQuickLinks,
  create: '24be8c2c-2f49-4524-bb9b-401a1fb57428',
  view: '8a1656d7-3b29-4293-bc21-94350f6afaaa',
  edit: '0814667c-2ca3-4f04-8de6-edc43eb882c9',
  removeRestore: '74496b1f-2136-4cd5-9195-ac753529ea34',
})

export const CreateEJQuickLink = quickLinks.Create
export const ViewEJQuickLink = quickLinks.View
export const EditEJQuickLink = quickLinks.Edit
export const RemoveRestoreEJQuickLink = quickLinks.RemoveRestore

export type EJQuickLinkPermission =
  | typeof CreateEJQuickLink
  | typeof ViewEJQuickLink
  | typeof EditEJQuickLink
  | typeof RemoveRestoreEJQuickLink
